import { MapfreButtonComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreLoadingComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-loading/mapfre-loading.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { Router , RouterModule } from '@angular/router';
import { TwoFADataService } from '@services/data-services/twoFA-data.service';
import { AcmicService } from '@mapfre-design-library/src/public_api';
import { PhoneFormatter } from '@helpers/_formatters/phone-formatter';
import { UserDataService } from '@services/data-services/user-data.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreLoadingComponent, MapfreButtonComponent],
  selector: 'app-two-factor-authentication',
  templateUrl: './two-factor-authentication.component.html',
  styleUrls: ['./two-factor-authentication.component.scss'],
})
export class TwoFactorAuthenticationComponent implements OnInit {

  phoneNumber = '';
  oktaEmail = '';
  isAcmic: boolean;
  showSuccessNotification = false;
  loading: boolean;

  constructor(
    private twoFADataService: TwoFADataService,
    private router: Router,
    private acmicService: AcmicService,
    private phoneFormatter: PhoneFormatter,
    private userDataService: UserDataService
  ) { }

  ngOnInit(): void {
    this.isAcmic = this.acmicService.isACMIC();
    const navState= history.state;
    if(navState && navState.phoneUpdated){
      this.showSuccessNotification = true;
    }
    
    this.loadPhoneNumber();
  }

  loadPhoneNumber(): void {
    this.loading=true;
    this.userDataService.$userData.subscribe((user) => {
      if (user && user.userDetails) {
        const rawPhone = user.userDetails?.mfaPhone;
        this.oktaEmail = user.userDetails?.email?.address;
        if(rawPhone){
          let digitsOnly = rawPhone.replace(/\D/g, '');
          if(digitsOnly.length>10){
            digitsOnly = digitsOnly.slice(digitsOnly.length-10);
          }
          const formatted = digitsOnly.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
          this.phoneNumber = this.phoneFormatter
          ? this.phoneFormatter.format(digitsOnly)
          : formatted;
        }
        this.loading=false;
      }
    });
  }

  editPhone(): void {
    const userDetails = this.userDataService.details.value?.userDetails;
    this.router.navigate(['/profile', 'edit-two-factor-authentication'], {
      state: { 
        currentPhone: this.phoneNumber, 
        mfaFactorId: userDetails?.mfaFactorId,
        oktaUserId: userDetails?.oktaUserId
      }
    });
  }

  onClose(){
    this.showSuccessNotification = false
  }
}
